<div>
    <div class="card m-2">
        <div mat-dialog-title class="heading">Update Metadata
            <!-- <mat-divider></mat-divider> -->
        </div>
        <div class="ml-3" class="properties" *ngIf="toggleUpdate">
            <div class="mt-2" style="text-align: center;">Please provide the updated values</div>
            <form #initiateForm="ngForm">
                <div *ngFor="let key of document.categoryMetaData.properties; index as i;">
                    <div *ngIf="key.required==true">
                        <div *ngIf="key.data_type=='str' && !key.isHide" class="input-group-sm mt-2 input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{key.name}} *</span>
                            </div>
                            <input class="form-control" name="{{key.name}}"
                                [ngClass]="values[key.name]?'':'empty-input'" ngDefaultControl type="text" [(ngModel)]="values[key.name]"
                                required>
                        </div>
                        <div *ngIf="key.data_type=='int' && !key.isHide" class="input-group-sm mt-2 input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{key.name}} *</span>
                            </div>
                            <input class="form-control" name="{{key.name}}"
                                [ngClass]="values[key.name]?'':'empty-input'" type="number" ngDefaultControl
                                [(ngModel)]="values[key.name]" required>
                        </div>
                        <div *ngIf="key.data_type=='date' && !key.isHide" class="input-group-sm mt-2 input-group col-12">
                            <!-- <div class="input-group-prepend">
                                <span class="input-group-text">{{key.name}} *</span>
                            </div>
                            <input class="form-control" name="{{key.name}}"
                                [ngClass]="values[key.name]?'':'empty-input'" type="date" [ngModel]="values[key.name] | date:'yyyy-MM-dd'"
                                (change)="updateList(values, key.name, $event)"
                                (ngModel)="values[key.name] = $any($event).target.valueAsDate"
                                required> -->
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{key.name}} *</span>
                            </div>
                            <div>
                                <input class="form-control" name="{{key.name}}" [matDatepicker]="datePicker"
                                [ngModel]="values[key.name] | date:'yyyy-MM-dd'" (ngModel)="values[key.name] = $any($event).target.valueAsDate"
                                (dateChange)="updateList(values, key, $event)" required>
                            </div>
                            <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
                            <mat-datepicker #datePicker></mat-datepicker>
                            <mat-error *ngIf="key.isError">
                                Date is invalid.
                            </mat-error>
                        </div>
                        <div *ngIf="key.data_type=='bool' && !key.isHide" class="input-group-sm mt-2 input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{key.name}} *</span>
                            </div>
                            <!-- <mat-slide-toggle ngDefaultControl class="ml-2" name="{{key.name}}" [(ngModel)]="values[key.name]">
                            </mat-slide-toggle> -->
                            <mat-select (selectionChange)="onSelectionChange($event)" ngDefaultControl class="form-control" name="{{key.name}}"
                                type="list"  [(ngModel)]="values[key.name]">                                
                                <mat-option value="true">True</mat-option>
                                <mat-option value="false">False</mat-option>
                            </mat-select>
                        </div>
                        <div *ngIf="key.data_type=='str array' && !key.isHide" class="input-group-sm mt-2 input-group col-12"
                            style="display: block;">
                            <form class="card p-2" [formGroup]="valuesForm">
                                <div formArrayName="{{key.name}}">
                                    <div class="row">
                                        <span class="form-group ml-3 form-label-105"
                                            style="font-size: small;">{{key.name}} *</span>
                                        <div class="col mb-2">
                                            <!-- <button mat-stroked-button > -->
                                            <mat-icon class="float-right" title="Add Value"
                                                (click)="addNewValue(key.name)">add</mat-icon>
                                            <!-- </button> -->
                                        </div>
                                    </div>
                                    <div *ngFor="let item of getValues(valuesForm, key.name); let i=index"
                                        [formGroupName]="i">
                                        <div class="row">
                                            <div class="col-11">
                                                <div class="row">
                                                    <div class="input-group-sm mt-2 input-group col-12 mb-2">
                                                        <input class="form-control" type="text"
                                                            [ngClass]="valuesForm.value[key.name][i].value!=''?'':'empty-input'"
                                                            formControlName="value" required>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-1 p-0">
                                                <mat-icon (click)="deleteForm(i,key.name)" style="position: relative;
                                            top: 15%;" *ngIf="valuesArray(key.name).controls.length > 1">delete
                                                </mat-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div *ngIf="key.data_type=='object' && !key.isHide" class="input-group-sm mt-2 input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{key.name}} *</span>
                            </div>
                             <json-editor [options]="makeOptions()"
                                        [data]="values[key.name]"
                                        (change)="getData($event, i)"
                                        >
                                    
                            </json-editor>
                        </div>
                        <div *ngIf="key.data_type=='options' && !key.isHide" class="input-group-sm mt-2 input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{key.name}} *</span>
                            </div>

                            <mat-select ngDefaultControl class="form-control" name="{{key.name}}"
                                [ngClass]="values[key.name]?'':'empty-input'"
                                type="list" [(ngModel)]="values[key.name]"
                                required>
                                <mat-option value="{{value}}" *ngFor="let value of key.values">{{value}}</mat-option>
                            </mat-select>
                        </div>
                    </div>
                    <div *ngIf="key.required==false">
                        <div *ngIf="key.data_type=='str' && !key.isHide" class="input-group-sm mt-2 input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{key.name}} </span>
                            </div>
                            <input class="form-control" name="{{key.name}}" ngDefaultControl type="text" [(ngModel)]="values[key.name]">
                        </div>
                        <div *ngIf="key.data_type=='int' && !key.isHide" class="input-group-sm mt-2 input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{key.name}} </span>
                            </div>
                            <input class="form-control" name="{{key.name}}" type="number" ngDefaultControl
                                [(ngModel)]="values[key.name]">
                        </div>
                        <div *ngIf="key.data_type=='date' && !key.isHide" class="input-group-sm mt-2 input-group col-12">
                            <!-- <div class="input-group-prepend">
                                <span class="input-group-text">{{key.name}} </span>
                            </div>
                            <input class="form-control" name="{{key.name}}" type="date" [ngModel]="values[key.name] | date:'yyyy-MM-dd'"
                            (change)="updateList(values, key.name, $event)"
                            (ngModel)="values[key.name] = $any($event).target.valueAsDate"> -->
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{key.name}} </span>
                            </div>
                            <div >
                                <input class="form-control" name="{{key.name}}" [matDatepicker]="datePicker"
                                [ngModel]="values[key.name] | date:'yyyy-MM-dd'" (ngModel)="values[key.name] = $any($event).target.value" (dateChange)="updateList(values, key, $event)">
                            </div>
                            <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
                            <mat-datepicker #datePicker></mat-datepicker>
                            <mat-error *ngIf="key.isError">
                                Date is invalid.
                            </mat-error>
                        </div>
                        <div *ngIf="key.data_type=='bool' && !key.isHide" class="input-group-sm mt-2 input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{key.name}}</span>
                            </div>
                            <mat-select (selectionChange)="onSelectionChange($event)" ngDefaultControl class="form-control" name="{{key.name}}"
                                type="list"  [(ngModel)]="values[key.name]">                                
                                <mat-option value="true">True</mat-option>
                                <mat-option value="false">False</mat-option>
                            </mat-select>
                        </div>
                        <div *ngIf="key.data_type=='object' && !key.isHide" class="input-group-sm mt-2 input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{key.name}}</span>
                            </div>
                            <json-editor [options]="makeOptions()"
                                        [data]="values[key.name]"
                                        (change)="getData($event, i)"
                                        >
                                    </json-editor>
                        </div>
                        <div *ngIf="key.data_type=='options' && !key.isHide" class="input-group-sm mt-2 input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{key.name}}</span>
                            </div>
                            <mat-select (selectionChange)="onSelectionChange($event)" class="form-control" name="{{key.name}}"
                                type="list" ngDefaultControl [(ngModel)]="values[key.name]">
                                <mat-option value="{{value}}" *ngFor="let value of key.values">{{value}}</mat-option>
                            </mat-select>
                        </div>
                        <div *ngIf="key.data_type=='str array' && !key.isHide" class="input-group-sm mt-2 input-group col-12"
                            style="display: block;">
                            <form class="card p-2" [formGroup]="valuesForm">
                                <div formArrayName="{{key.name}}">
                                    <div class="row">
                                        <span class="form-group ml-3 form-label-105"
                                            style="font-size: small;">{{key.name}}</span>
                                        <div class="col mb-2">
                                            <!-- <button mat-stroked-button > -->
                                            <mat-icon class="float-right" title="Add Value"
                                                (click)="addNewValue(key.name)">add</mat-icon>
                                            <!-- </button> -->
                                        </div>
                                    </div>
                                    <div *ngFor="let item of getValues(valuesForm,key.name); let i=index"
                                        [formGroupName]="i">
                                        <div class="row">
                                            <div class="col-11">
                                                <div class="row">
                                                    <div class="input-group-sm mt-2 input-group col-12 mb-2">
                                                        <input class="form-control" type="text" formControlName="value">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-1 p-0">
                                                <mat-icon (click)="deleteForm(i,key.name)" style="position: relative;
                                                        top: 15%;">delete
                                                </mat-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div>
                    <button class="closeButton mat-raised-button  float-right m-2"  (click)="onCancel()">Cancel</button>
                    <button class="actionButton mat-raised-button  float-right m-2" type="submit"
                        [disabled]="!initiateForm.valid" (click)="updateMetadata()">Update</button>
                </div>
            </form>
        </div>

        <div *ngIf="updateMessage">
            <div>Document Metadata has been updated successfully.</div>
            <button class="closeButton mat-raised-button  float-right m-2" (click)="onClose()">Close</button>
        </div>
        <div *ngIf="isError">
            <div style="text-align: center; color: red;">{{errorMessage}}</div>
        </div>
    </div>
</div>